var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#FFFFFF","strokeWidth":"2","d":"M10,0v73","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M20,71.5C16,74,12.6,77.9,10,82c-2.5-4.2-6-7.9-10-10.5V69c4,2.6,7.4,5.7,10,9.6c2.7-3.9,6-7.1,10-9.7V71.5z\n\t M20,65.5C16,68,12.6,71.9,10,76c-2.5-4.2-6-7.9-10-10.5V63c4,2.6,7.4,5.7,10,9.6c2.7-3.9,6-7.1,10-9.7V65.5z","key":1})]);
}

ArrowInline.defaultProps = {"x":"0px","y":"0px","width":"20","height":"82","viewBox":"0 0 20 82","style":{"enableBackground":"new 0 0 20 82"},"xmlSpace":"preserve"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
